/**
 * Get coordinates for layout
 * total width of the grid is 8 columns
 * total height is 4 rows
 * @returns Array
 */
export const getLayout = (gridType: number) => {
    // i is used for keys for loop
    // x/y are coordinates
    // w/h width and height
    switch (gridType) {
        case 2:
            return [
                {i: "1", x: 0, y: 0, w: 2, h: 4, static: true},
                {i: "2", x: 2, y: 0, w: 2, h: 4, static: true},
                {i: "3", x: 4, y: 0, w: 4, h: 4, static: true},
                {i: "4", x: 0, y: 4, w: 8, h: 4, static: true},
            ];
        case 3:
            return [
                {i: "1", x: 0, y: 0, w: 2, h: 4, static: true},
                {i: "2", x: 2, y: 0, w: 2, h: 4, static: true},
                {i: "3", x: 4, y: 0, w: 2, h: 4, static: true},
                {i: "4", x: 6, y: 0, w: 2, h: 4, static: true},
                {i: "5", x: 0, y: 4, w: 8, h: 4, static: true},
            ];
        case 4:
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 8, static: true},
                {i: "2", x: 4, y: 0, w: 2, h: 4, static: true},
                {i: "3", x: 6, y: 0, w: 2, h: 4, static: true},
                {i: "4", x: 4, y: 4, w: 2, h: 4, static: true},
                {i: "5", x: 6, y: 4, w: 2, h: 4, static: true},
            ];
        case 5:
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 4, static: true},
                {i: "2", x: 4, y: 0, w: 2, h: 4, static: true},
                {i: "3", x: 6, y: 0, w: 2, h: 4, static: true},
                {i: "4", x: 0, y: 4, w: 2, h: 4, static: true},
                {i: "5", x: 2, y: 4, w: 2, h: 4, static: true},
                {i: "6", x: 4, y: 4, w: 2, h: 4, static: true},
                {i: "7", x: 6, y: 4, w: 2, h: 4, static: true},
            ];
        case 6:
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 8, static: true},
                {i: "2", x: 4, y: 0, w: 2, h: 4, static: true},
                {i: "3", x: 6, y: 0, w: 2, h: 4, static: true},
                {i: "4", x: 4, y: 4, w: 1, h: 2, static: true},
                {i: "5", x: 5, y: 4, w: 1, h: 2, static: true},
                {i: "6", x: 4, y: 6, w: 1, h: 2, static: true},
                {i: "7", x: 5, y: 6, w: 1, h: 2, static: true},
                {i: "8", x: 6, y: 4, w: 2, h: 4, static: true},
            ];
        case 7:
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 4, static: true},
                {i: "2", x: 4, y: 0, w: 2, h: 4, static: true},
                {i: "3", x: 6, y: 0, w: 2, h: 4, static: true},
                {i: "4", x: 0, y: 4, w: 1, h: 2, static: true},
                {i: "5", x: 1, y: 4, w: 1, h: 2, static: true},
                {i: "6", x: 2, y: 4, w: 1, h: 2, static: true},
                {i: "7", x: 3, y: 4, w: 1, h: 2, static: true},
                {i: "8", x: 0, y: 6, w: 1, h: 2, static: true},
                {i: "9", x: 1, y: 6, w: 1, h: 2, static: true},
                {i: "10", x: 2, y: 6, w: 1, h: 2, static: true},
                {i: "11", x: 3, y: 6, w: 1, h: 2, static: true},
                {i: "12", x: 4, y: 4, w: 2, h: 4, static: true},
                {i: "13", x: 6, y: 4, w: 2, h: 4, static: true},
            ];
        case 8:
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 4, static: true},
                {i: "2", x: 4, y: 0, w: 4, h: 4, static: true},
                {i: "3", x: 0, y: 4, w: 4, h: 4, static: true},
                {i: "4", x: 4, y: 4, w: 4, h: 4, static: true},
            ];
		case 9:
			return [
				{i: "1", x: 0, y: 0, w: 8, h: 8, static: true}
			];
        case 10:
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 8, static: true},
                {i: "2", x: 4, y: 0, w: 4, h: 8, static: true}
            ];
        case 11:
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 8, static: true},
                {i: "2", x: 4, y: 0, w: 4, h: 4, static: true},
                {i: "3", x: 4, y: 4, w: 4, h: 3, static: true},
                {i: "4", x: 4, y: 7, w: 2, h: 1, static: true},
                {i: "5", x: 6, y: 7, w: 2, h: 1, static: true},
            ];
        case 12: 
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 4, static: true},
                {i: "2", x: 4, y: 0, w: 4, h: 4, static: true},
                {i: "3", x: 0, y: 4, w: 4, h: 4, static: true},
                {i: "4", x: 4, y: 4, w: 4, h: 3, static: true},
                {i: "5", x: 4, y: 7, w: 2, h: 1, static: true},
                {i: "6", x: 6, y: 7, w: 2, h: 1, static: true},
            ]
		case 13:
			return [
				{ i: "1", x: 0, y: 0, w: 4, h: 8, static: true },
				{ i: "2", x: 4, y: 0, w: 4, h: 3.7, static: true },
				{ i: "3", x: 4, y: 3.7, w: 4, h: 3.2, static: true },
				{ i: "4", x: 4, y: 7, w: 2, h: 1, static: true },
				{ i: "5", x: 6, y: 7, w: 2, h: 1, static: true },
			];
        case 14:
            return [
                { i: "1", x: 0, y: 0, w: 2.66, h: 4, static: true },
                { i: "2", x: 2.66, y: 0, w: 2.66, h: 4, static: true },
                { i: "3", x: 5.33, y: 0, w: 2.66, h: 4, static: true },
                { i: "4", x: 0, y: 4, w: 2.66, h: 4, static: true },
                { i: "5", x: 2.66, y: 4, w: 2.66, h: 4, static: true },
                { i: "6", x: 5.33, y: 4, w: 2.66, h: 4, static: true },
            ];
        case 15:
            return [
                { i: "1", x: 0, y: 0, w: 4, h: 2.66, static: true },
                { i: "2", x: 4, y: 0, w: 4, h: 2.66, static: true },
                { i: "3", x: 0, y: 2.66, w: 4, h: 2.66, static: true },
                { i: "4", x: 4, y: 2.66, w: 4, h: 2.66, static: true },
                { i: "5", x: 0, y: 5.33, w: 4, h: 2.66, static: true },
                { i: "6", x: 4, y: 5.33, w: 4, h: 2.66, static: true },
            ];
        case 16: 
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 8, static: true},
                {i: "2", x: 4, y: 0, w: 1, h: 2, static: true},
                {i: "3", x: 5, y: 0, w: 1, h: 2, static: true},
                {i: "4", x: 6, y: 0, w: 1, h: 2, static: true},
                {i: "5", x: 7, y: 0, w: 1, h: 2, static: true},
                {i: "6", x: 4, y: 2, w: 1, h: 2, static: true},
                {i: "7", x: 5, y: 2, w: 1, h: 2, static: true},
                {i: "8", x: 6, y: 2, w: 1, h: 2, static: true},
                {i: "9", x: 7, y: 2, w: 1, h: 2, static: true},
                {i: "10", x: 4, y: 4, w: 1, h: 2, static: true},
                {i: "11", x: 5, y: 4, w: 1, h: 2, static: true},
                {i: "12", x: 6, y: 4, w: 1, h: 2, static: true},
                {i: "13", x: 7, y: 4, w: 1, h: 2, static: true},
                {i: "14", x: 4, y: 6, w: 1, h: 2, static: true},
                {i: "15", x: 5, y: 6, w: 1, h: 2, static: true},
                {i: "16", x: 6, y: 6, w: 1, h: 2, static: true},
                {i: "17", x: 7, y: 6, w: 1, h: 2, static: true}
            ]
        default:
            return [
                {i: "1", x: 0, y: 0, w: 4, h: 8, static: true},
                {i: "2", x: 4, y: 0, w: 4, h: 4, static: true},
                {i: "3", x: 4, y: 4, w: 2, h: 4, static: true},
                {i: "4", x: 6, y: 4, w: 2, h: 4, static: true},
            ];
    }
}
